import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state: {
    shipmentContentItems: {
      items: [],
      count: '',
      entity: {},
    },
    shipmentContentItem: {}
  },
  actions,
  mutations,
  getters,
};
